import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useAddCoworker = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["chat_add_coworker"],
    mutationFn: async (query) => {
      return await axios.post("/chat/addcoworker", query);
    },
  });
};
